// @ts-nocheck
import * as React from 'react';
import { storiesOf } from '@storybook/react';
import { StorybookComponents } from '@wix/wix-storybook-utils/StorybookComponents';
import { VisualTestContainer } from '../../../test/visual/VisualTestContainer';
import { Fieldset } from '.';
import { classes } from './Fieldset.visual.st.css';

storiesOf('Internal/Fieldset', module)
  .add('Simple', () => {
    return (
      <VisualTestContainer>
        <Fieldset label="Label" errorMessage="Error">
          <StorybookComponents.Placeholder>
            Children
          </StorybookComponents.Placeholder>
        </Fieldset>
      </VisualTestContainer>
    );
  })
  .add('Style Overrides', () => {
    return (
      <VisualTestContainer>
        <StorybookComponents.Stack flexDirection="column" gap="0">
          <Fieldset label="Label" errorMessage="Error" className={classes.root}>
            <StorybookComponents.Placeholder>
              Children
            </StorybookComponents.Placeholder>
          </Fieldset>
          <StorybookComponents.Placeholder>
            Other component
          </StorybookComponents.Placeholder>
        </StorybookComponents.Stack>
      </VisualTestContainer>
    );
  });
